import { render } from "./courseware.vue?vue&type=template&id=0dde3395&scoped=true"
import script from "./courseware.vue?vue&type=script&lang=js"
export * from "./courseware.vue?vue&type=script&lang=js"

import "./courseware.vue?vue&type=style&index=0&id=0dde3395&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dde3395"]])

export default __exports__